import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Markdown from 'components/atoms/Markdown';

import ClickToCopy from 'components/molecules/ClickToCopy';

import styles from './BigFooter.module.scss';

const BigFooter = ({ className }: { className?: string }) => {
  const intl = useIntl();

  return (
    <div className={`${styles.box} ${className || ''}`}>
      <footer className={styles.footer}>
        <div className="flex fdc jcsb f1 prel">
          <div className={styles.logoContainer} />
          <div className="flex gap32">
            <div className={styles.colunm}>
              <div className={styles.bigTitle}>About</div>
              <div className={styles.smallLink}>
                <Markdown>
                  {intl.formatMessage(
                    { id: 'KolLandingPage.footer.aboutKolsquare' },
                    { defaultMessage: 'About Kolsquare' },
                  )}
                </Markdown>
              </div>
              <div className={styles.smallLink}>
                <Markdown>
                  {intl.formatMessage({ id: 'KolLandingPage.footer.product' }, { defaultMessage: '#Product' })}
                </Markdown>
              </div>
              <div className={styles.smallLink}>
                <Markdown>
                  {intl.formatMessage(
                    { id: 'KolLandingPage.footer.influenceForGood' },
                    { defaultMessage: '#InfluenceforGood' },
                  )}
                </Markdown>
              </div>
            </div>

            <div className={styles.colunm}>
              <div className={styles.bigTitle}>Resources</div>
              <div className={styles.smallLink}>
                <Markdown>
                  {intl.formatMessage({ id: 'KolLandingPage.footer.blog' }, { defaultMessage: 'Free Blog' })}
                </Markdown>
              </div>
              <div className={styles.smallLink}>
                <Markdown>
                  {intl.formatMessage(
                    { id: 'KolLandingPage.footer.freeResources' },
                    { defaultMessage: 'Free Resources' },
                  )}
                </Markdown>
              </div>
            </div>

            <div className={styles.colunm}>
              <div className={styles.bigTitle}>
                <FormattedMessage id="KolLandingPage.footer.getInTouch" defaultMessage="Get in touch" />
              </div>
            </div>
          </div>
          <div className="flex gap32 jcsb aife">
            <p className={styles.adressContainer}>
              124, rue Réaumur
              <br />
              75002 Paris – France
              <br />
              <a href="mailto:contact@kolsquare.com" target="_blank" rel="noopener noreferrer">
                contact@kolsquare.com
              </a>
              <br />
              <br />
              <a href="www.kolsquare.com" target="_blank" rel="noopener noreferrer">
                www.kolsquare.com
              </a>
            </p>

            <div className="flex fdc gap22 aife">
              <img
                className={styles.bCorpLogo}
                alt="footer-logo-bcorp.png"
                srcSet="https://static.kolsquare.com/assets/kol_landing_page/footer-logo-bcorp.png 1.5x"
              />
              <div className={styles.socialIconsContainer}>
                <ClickToCopy text="www.kolsquare.com">
                  <img
                    alt="Icon link intact"
                    srcSet="https://static.kolsquare.com/assets/kol_landing_page/footer-logo-link.png 1.5x"
                  />
                </ClickToCopy>

                <a href="https://www.linkedin.com/company/kolsquare/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt="Icon social linkedin"
                    srcSet="https://static.kolsquare.com/assets/kol_landing_page/footer-logo-linkedin.png 1.5x"
                  />
                </a>
                <a href="https://www.instagram.com/kolsquare/" target="_blank" rel="noopener noreferrer">
                  <img
                    alt="Icon instagram fill"
                    srcSet="https://static.kolsquare.com/assets/kol_landing_page/footer-logo-instagram.png 1.5x"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BigFooter;
